import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { PageSection, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { getIntegrations } from '../constants/Integrations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const IntegrationsSection = ({
  nav
}) => {
  const integrations = getIntegrations(nav);
  const content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.integrations.title"
        })
      }), /*#__PURE__*/_jsx(SectionSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "pricingPage.integrations.subtitle_jsx",
          elements: {
            FormattedNumber
          }
        })
      })]
    }), /*#__PURE__*/_jsx(Flex, {
      flexWrap: "wrap",
      alignItems: "stretch",
      justifyContent: "center",
      children: integrations.map(({
        appName,
        logo
      }) => /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        maxInlineSize: "104px",
        inlineSize: "100%",
        blockSize: "100%",
        children: [/*#__PURE__*/_jsx(Image, {
          src: logo,
          blockSize: "48px",
          inlineSize: "48px",
          margin: "400",
          role: "img"
        }), /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          children: appName
        })]
      }, appName))
    })]
  });
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsx(CardWrapper, {
      marginBlock: "0",
      paddingBlock: "1300",
      children: /*#__PURE__*/_jsx(CardSection, {
        padding: "0",
        children: content
      })
    })
  });
};